import { ServiceCodeBySystem, IntegrationSystem } from '@/shared/types';

import { config } from '@/config/index';

import { RouteConfig } from '@/router/types';
import { getFullRoutePath } from '@/router/utils/getFullRoutePath';

export const IAC_ROUTES: Record<keyof ServiceCodeBySystem<IntegrationSystem.IAC>, RouteConfig> = {
  CRIMINAL_RECORD_SEARCH: {
    basePath: config.router.servicePath,
    path: 'criminal-record-search',
    isPrivate: false,
  },
  CRIMINAL_RECORD_SEARCH_ALL: {
    basePath: config.router.userPath,
    path: 'criminal-record-search-all',
    isPrivate: true,
  },
  EXTENDED_CRIMINAL_RECORD_EXTRACT: {
    basePath: config.router.servicePath,
    path: 'extended-criminal-record-extract',
    isPrivate: true,
  },
  EXTRACT_REDELIVERY: { basePath: config.router.servicePath, path: 'extract-redelivery', isPrivate: true },
};

export const IAC_ROUTES_LEGACY = [
  {
    LEGACY_PATH: '/search/iac',
    RELEVANT_PATH: getFullRoutePath(IntegrationSystem.IAC, IAC_ROUTES.CRIMINAL_RECORD_SEARCH),
  },
  {
    LEGACY_PATH: '/services/criminal-record-search/qr',
    RELEVANT_PATH: getFullRoutePath(IntegrationSystem.IAC, IAC_ROUTES.CRIMINAL_RECORD_SEARCH),
  },
  {
    LEGACY_PATH: '/services/criminal-record-search/qr-legacy',
    RELEVANT_PATH: getFullRoutePath(IntegrationSystem.IAC, IAC_ROUTES.CRIMINAL_RECORD_SEARCH),
  },
];
